import { z } from 'zod';

/**
 * `GET /api/health` — public liveness probe. Used by Cloud Run health checks
 * and the deploy smoke test.
 */
export const HealthResponseSchema = z.object({
  ok: z.literal(true),
  ts: z.number().int().positive(),
});

export type HealthResponse = z.infer<typeof HealthResponseSchema>;
